import React from 'react';

// helpers
import styled from 'styled-components';
import { colorsTheme } from '../../../resources/theme/styled/colors';
import { StyledComponentProps } from '../../../typings/common';

// components
import DivAlignCenter from '../DivAlignCenter';
import { Text, IconSVG } from '@ui';
import { ReactComponent as SharedDataIcon } from '../../../resources/icons/remix-icons/share-line.svg';

interface IProps extends StyledComponentProps {
  text: string;
}

const SharedIconWithText = ({ text, ...rest }: IProps) => {
  return (
    <DivAlignCenter {...rest}>
      <StyledIconSVG
        component={SharedDataIcon}
        color={colorsTheme.colorPrimary}
        size="middle"
      />
      <Text color={colorsTheme.colorLight}>{text}</Text>
    </DivAlignCenter>
  );
};

const StyledIconSVG = styled(IconSVG)`
  margin-right: ${({ theme }) => theme.marginXs};
`;

export default SharedIconWithText;
